export default __webpack_public_path__ + "static/media/Logo 40th 1.1fbb4195.png";